<template>
    <div>
        <Conection/>
    </div>
</template>

<script>
import Conection from './Connections/connection.vue'
    export default {
        components: { Conection }
        
    }
</script>

<style lang="scss" scoped>

</style>